/* Desktop product details 2026.
   Fills the still-empty detail slots from the product description. Nothing is
   invented: every sentence shown comes from the product record. */
(function () {
  var desktop = window.matchMedia('(min-width: 992px)');

  function build(details) {
    if (details.dataset.botBuilt === 'true') return;
    details.dataset.botBuilt = 'true';
    var source = details.querySelector('[data-slot="source"]');
    var descSlot = details.querySelector('[data-slot="description"]');
    if (!source || !descSlot) return;

    // Keep the complete remaining description; ingredient sections are moved
    // without the old heading parser dropping inline text or formatting.
    if (window.BotIngredientSections) window.BotIngredientSections.render(source, descSlot);
    else descSlot.innerHTML = source.innerHTML;
    descSlot.dataset.empty = 'false';

    // Sidebar metafield and taxonomy blocks remain authored in Liquid.
    // Do not derive duplicate summaries from the full description above.
  }

  function run() {
    document.querySelectorAll('[data-bot-pdp-details]').forEach(build);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  desktop.addEventListener('change', run);
  new MutationObserver(function (mutations) {
    var selector = '[data-bot-pdp-details]';
    var pending = new Set();
    function queue(details) {
      if (details && details.dataset.botBuilt !== 'true') pending.add(details);
    }
    mutations.forEach(function (mutation) {
      if (!mutation.addedNodes.length) return;
      var target = mutation.target;
      if (target.nodeType === 1) queue(target.closest(selector));
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches(selector)) queue(node);
        node.querySelectorAll(selector).forEach(queue);
      });
    });
    pending.forEach(build);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

